<template>
  <div class="content">
    <form>
      <h3>Впишите Новый Маршрут</h3>
      <table class="company-table">
        <thead>
          <tr>
            <th>Новый Маршрут</th>
            <th>Ставка без НДС</th>
            <th>Ставка c НДС</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><input v-model="formRoute" placeholder="москва-новосибирск" type="text" /></td>
            <td><input v-model="formBid" placeholder="20000" type="number" /></td>
            <td><input v-model="formBidTax" placeholder="22000" type="number" /></td>
          </tr>
        </tbody>
      </table>
      <ATIButtonComponent  @click="emitForm" inactive_button_text="Сохранить" class="send-btn"></ATIButtonComponent>
    </form>
  </div>
</template>

<script>
import ATIButtonComponent from './ATIButtonComponent.vue';
import { ref } from 'vue';

export default {
  components: {
    ATIButtonComponent,
  },
  props: {
    initialRoute: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const formRoute = ref(props.initialRoute || '');
    const formBidTax = ref('');
    const formBid = ref('');
    const form = ref([]);

    const emitForm = () => {
      form.value = {
        route: formRoute.value.trim(),
        bid: formBid.value,
        bid_tax: formBidTax.value,
      };

      emit('add-route', form.value);
    };

    return {
      formRoute,
      formBid,
      formBidTax,
      emitForm,
    };
  },
};
</script>

<style scoped>
  h3{
    text-align: center;
    margin-bottom: 10px;
  }

  input{
    padding: 2px;
  }
  .company-table {
    margin-right: 20px;
    border-collapse: collapse;
  }
  
  .company-table th,
  .company-table td {
    text-align: center;
    padding: 10px;
    border: 1px solid #ccc;
  }
  
  .company-table th {
    font-weight: bold;
  }

  .send-btn{
    margin-top: 15px;
  }
</style>